import { render } from "./EmployeeScreen.vue?vue&type=template&id=64e4ed1a&scoped=true"
import script from "./EmployeeScreen.vue?vue&type=script&lang=ts"
export * from "./EmployeeScreen.vue?vue&type=script&lang=ts"

import "./EmployeeScreen.vue?vue&type=style&index=0&id=64e4ed1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64e4ed1a"

export default script